import { useEffect, useState } from 'react';
import { Skeleton } from 'antd';
import { observer } from 'mobx-react';
import ActionCell from '$src/components/ActionCell';
import MenuSelectorGroup from '$src/components/MenuSelectorGroup';
import { Notify } from '$src/utils/notify';
import { ModalCustom } from '$src/components/Modal';
import useModalEvents from '$src/hooks/useModalEvents';
import useStores from '$src/hooks/useStores';
import useFeature from '$src/hooks/useFeature';
import useLocationId from '$src/hooks/useLocationId';
import { SIREN_ENABLED } from './contanst';

function SirenPreference() {
  const {
    sessionStore: { user },
    preferencesStore,
  } = useStores();
  const { fetchPreferences, preferences, loading, putPreferences, setPreferences } = preferencesStore;
  const [is1pModelEnabled] = useFeature('stark-feature-next-1P-model');

  // eslint-disable-next-line camelcase
  const { user_id } = user;
  const locationId = useLocationId();
  const [preferenceType, setPreferencesType] = useState(null);
  const [handleClick, toggleModal] = useModalEvents();

  useEffect(() => {
    if (locationId) fetchPreferences(user_id, locationId, false);
    // eslint-disable-next-line camelcase
  }, [fetchPreferences, locationId, user_id]);

  const handlePreferenceState = (value, preferenceSelected) => {
    const preferencesToUpdate = { ...preferences };
    preferencesToUpdate[preferenceSelected] = value;
    return preferencesToUpdate;
  };

  const handlePreferenceChange = async (preferenceTitle, subscribed, preferencesUpdated, preferenceSelected) => {
    try {
      await putPreferences(preferencesUpdated, user_id, locationId);
      Notify.success(`Preference ${preferenceTitle} successfully ${subscribed ? 'subscribed' : 'unsubscribed'}`);
    } catch (e) {
      Notify.error(`Error changing the preference ${preferenceTitle} to ${subscribed}`, e);
      const preferencesRollback = handlePreferenceState(!subscribed, preferenceSelected);
      setPreferences(preferencesRollback);
    } finally {
      setPreferencesType(null);
    }
  };

  const managePreference = (checked) => {
    const preferenceUpdated = handlePreferenceState(checked, 'sirenEnabled');
    // Update the preferences
    handlePreferenceChange('siren', checked, preferenceUpdated, 'sirenEnabled');
  };

  const handleOk = () => {
    managePreference(false);
    handleClick();
  };

  const handleCancel = () => {
    handleClick();
    setPreferencesType(null);
  };

  const onChange = (checked) => {
    setPreferencesType(SIREN_ENABLED);
    if (!checked) {
      handleClick();
    } else {
      managePreference(checked);
    }
  };

  return (
    <Skeleton active title paragraph={{ rows: 4 }} loading={loading}>
      <MenuSelectorGroup
        title="Siren Access"
        data-testid="siren-access"
        subTitle="In an emergency, agents can turn on the built-in sirens on your enrolled Ring Outdoor and Indoor devices when siren 
        access is enabled. Changing siren access here changes siren access for all enrolled devices above."
      >
        <ActionCell
          id="sirenEnabled"
          iconName="siren_off.svg"
          description=""
          type="toogle"
          value={preferences.sirenEnabled}
          onChange={() => onChange(!preferences.sirenEnabled)}
          loading={preferenceType === SIREN_ENABLED}
          data-testid="sirenEnabled"
        >
          Siren Access
        </ActionCell>
        <ModalCustom
          title="Siren"
          data-testid="siren-access-modal"
          contentTitle="Are you sure you want to turn the Siren Option off?"
          icon="siren_off.svg"
          contentMessage={
            is1pModelEnabled
              ? "This will prevent Ring’s monitoring center from using the siren to help deter unwanted behavior."
              : "This will prevent Rapid Response's Monitoring Specialists from using the siren to help deter unwanted behavior."
          }
          setModalVisible={handleCancel}
          visible={toggleModal}
          handleOk={handleOk}
          okText="Turn Off Siren"
          cancelText="Cancel"
        />
      </MenuSelectorGroup>
    </Skeleton>
  );
}

export default observer(SirenPreference);
